import {
    deleteUserNotificationsErrorMessage,
    deleteUserNotificationsSuccessMessage,
    getUserNotifications,
    getUserNotificationsErrorMessage,
    getUserNotificationsSuccessMessage,
    reviewSkillChangeNotificationFailure,
    reviewSkillChangeNotificationSuccess,
    setUserNotifications,
} from "../../features/Notification/notificationSlice";
import {apiPython as api} from "../../../service/api";
import { isSessionValueReady } from "../../../utils/helpers";
import URLs from "../../../constants/urls";
import { all, put, takeEvery } from 'redux-saga/effects';
import {
    DELETE_USER_NOTIFICATION,
    GET_USER_NOTIFICATION,
    REVIEW_SKILL_CHANGE_NOTIFICATION,
} from "../../actions/Notification/actionType";
import { getSessionStorage } from '../../../utils/helpers';

export function* getUserNotificationSaga({payload}) {
    try {
        if (!isSessionValueReady(payload)) {
            yield put(getUserNotificationsErrorMessage('User session not initialized'));
            return;
        }
        const response = yield api.get(`${URLs.GET_USER_NOTIFICATIONS}?loggedUserID=${payload}`);
        if (response?.data?.statusCode == 200) {
            yield put(getUserNotificationsSuccessMessage(response?.data?.message));
            const raw = response?.data?.data;
            yield put(setUserNotifications(Array.isArray(raw) ? raw : []));
        } else {
            yield put(getUserNotificationsErrorMessage(response?.data?.message || 'Something went wrong'));
        }
    } catch (error) {
        yield put(getUserNotificationsErrorMessage('Something went wrong'));
    }
}

export function* deleteUserNotificationSaga({ payload }) {
    try {
        const deletedId = payload?.data?.id ?? payload?.data?.notificationId;
        const response = yield api.post(URLs.DELETE_USER_NOTIFICATION, payload?.data);
        if (response?.data?.statusCode == 200) {
            yield put(
                deleteUserNotificationsSuccessMessage({
                    message: response?.data?.message,
                    deletedId,
                })
            );
            const uid = payload?.data?.loggedUserID || getSessionStorage('USER_ID');
            if (isSessionValueReady(uid)) {
                yield put(getUserNotifications(uid));
            }
        } else {
            yield put(
                deleteUserNotificationsErrorMessage(
                    response?.data?.message || 'Something went wrong'
                )
            );
        }
    } catch (error) {
        yield put(deleteUserNotificationsErrorMessage('Something went wrong'));
    }
}

export function* reviewSkillChangeNotificationSaga({ payload }) {
    try {
        const response = yield api.post(URLs.REVIEW_SKILL_CHANGE_REQUEST, payload);
        if (response?.data?.statusCode == 200) {
            yield put(reviewSkillChangeNotificationSuccess(response?.data?.message || 'Done'));
            const uid = getSessionStorage('USER_ID');
            if (uid) {
                yield put(getUserNotifications(uid));
            }
        } else {
            yield put(
                reviewSkillChangeNotificationFailure(
                    response?.data?.message || 'Something went wrong'
                )
            );
        }
    } catch (error) {
        yield put(
            reviewSkillChangeNotificationFailure(
                error?.response?.data?.message || 'Something went wrong'
            )
        );
    }
}

export function* watchUserNotification() {
    yield takeEvery(GET_USER_NOTIFICATION, getUserNotificationSaga);
    yield takeEvery(DELETE_USER_NOTIFICATION, deleteUserNotificationSaga);
    yield takeEvery(REVIEW_SKILL_CHANGE_NOTIFICATION, reviewSkillChangeNotificationSaga);
}

export default function* userNotificationSaga() {
    yield all([watchUserNotification()]);
}